export const ToothDetailPanel = {
  flow: 'y',
  gap: 'A',
  padding: 'B',
  background: 'inkSurface',
  round: 'Z',
  border: '1px solid inkBorder',
  width: 'G',
  maxHeight: '80vh',
  overflow: 'auto',
  show: (el, s) => s.root.selectedTooth !== null && s.root.selectedTooth !== undefined,

  PanelHeader: {
    flow: 'x',
    align: 'center space-between',

    ToothInfo: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',

      ToothNumber: {
        text: (el, s) => '#' + (s.root.selectedTooth || ''),
        fontSize: 'D',
        fontWeight: '800',
        color: 'teal'
      },

      ToothName: {
        text: (el, s) => {
          var names = {
            11: 'Central Incisor', 12: 'Lateral Incisor', 13: 'Canine',
            14: 'First Premolar', 15: 'Second Premolar', 16: 'First Molar',
            17: 'Second Molar', 18: 'Third Molar',
            21: 'Central Incisor', 22: 'Lateral Incisor', 23: 'Canine',
            24: 'First Premolar', 25: 'Second Premolar', 26: 'First Molar',
            27: 'Second Molar', 28: 'Third Molar',
            31: 'Central Incisor', 32: 'Lateral Incisor', 33: 'Canine',
            34: 'First Premolar', 35: 'Second Premolar', 36: 'First Molar',
            37: 'Second Molar', 38: 'Third Molar',
            41: 'Central Incisor', 42: 'Lateral Incisor', 43: 'Canine',
            44: 'First Premolar', 45: 'Second Premolar', 46: 'First Molar',
            47: 'Second Molar', 48: 'Third Molar'
          }
          return names[s.root.selectedTooth] || 'Tooth'
        },
        fontSize: 'Z',
        color: 'inkMuted',
        fontWeight: '500'
      }
    },

    CloseButton: {
      extends: 'Icon',
      icon: 'x',
      fontSize: 'A',
      color: 'inkMuted',
      cursor: 'pointer',
      onClick: (el, s) => {
        s.root.update({ selectedTooth: null, selectedSurface: null })
      }
    }
  },

  StatusSection: {
    flow: 'y',
    gap: 'Y',

    StatusLabel: {
      text: '{{ status | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    StatusDropdown: {
      tag: 'select',
      padding: 'Y Z',
      round: 'Y',
      border: '1px solid inkBorder',
      background: 'inkMid',
      color: 'inkText',
      fontSize: 'Z',
      width: '100%',
      cursor: 'pointer',
      value: (el, s) => {
        var td = s.root.toothData && s.root.toothData[s.root.selectedTooth]
        return td && td.status ? td.status : 'healthy'
      },
      onChange: (el, s) => {
        var val = el.node.value
        var toothData = Object.assign({}, s.root.toothData || {})
        var num = s.root.selectedTooth
        toothData[num] = Object.assign({}, toothData[num] || {}, { status: val })
        s.root.update({ toothData: toothData })
      },
      OptionHealthy: { tag: 'option', value: 'healthy', text: '{{ healthy | polyglot }}' },
      OptionCaries: { tag: 'option', value: 'caries', text: '{{ caries | polyglot }}' },
      OptionRestored: { tag: 'option', value: 'restored', text: '{{ restored | polyglot }}' },
      OptionMissing: { tag: 'option', value: 'missing', text: '{{ missing | polyglot }}' },
      OptionImplant: { tag: 'option', value: 'implant', text: '{{ implant | polyglot }}' },
      OptionCrown: { tag: 'option', value: 'crown', text: '{{ crownStatus | polyglot }}' },
      OptionBridge: { tag: 'option', value: 'bridge', text: '{{ bridge | polyglot }}' },
      OptionVeneer: { tag: 'option', value: 'veneer', text: '{{ veneer | polyglot }}' }
    }
  },

  SurfaceSection: {
    flow: 'y',
    gap: 'Y',

    SurfaceLabel: {
      text: '{{ surfaces | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    SurfaceList: {
      flow: 'y',
      gap: 'X',
      childExtends: {
        flow: 'x',
        align: 'center space-between',
        padding: 'X Z',
        round: 'X',
        background: 'inkMid',
        border: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var td = s.root.toothData && s.root.toothData[s.root.selectedTooth]
        var surfaces = td && td.surfaces ? td.surfaces : {}
        var names = ['buccal', 'lingual', 'mesial', 'occlusal', 'distal']
        return names.map(function (name) {
          return {
            SurfaceName: { text: name.charAt(0).toUpperCase() + name.slice(1), fontSize: 'Y', color: 'inkText', fontWeight: '500' },
            SurfaceStatus: {
              text: (surfaces[name] || 'healthy').charAt(0).toUpperCase() + (surfaces[name] || 'healthy').slice(1),
              fontSize: 'Y',
              color: (surfaces[name] === 'caries') ? 'red' : (surfaces[name] === 'restored') ? 'blue' : 'green',
              fontWeight: '600'
            }
          }
        })
      }
    }
  },

  HistorySection: {
    flow: 'y',
    gap: 'Y',

    HistoryLabel: {
      text: '{{ procedureHistory | polyglot }}',
      fontSize: 'Y',
      color: 'inkMuted',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    HistoryList: {
      flow: 'y',
      gap: 'X',
      childExtends: {
        flow: 'x',
        align: 'center space-between',
        padding: 'Y Z',
        borderBottom: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        return [
          {
            ProcName: { text: '{{ compositeFilling | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' },
            ProcDate: { text: '2025-11-15', fontSize: 'Y', color: 'inkMuted' }
          },
          {
            ProcName: { text: '{{ xray | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' },
            ProcDate: { text: '2025-08-20', fontSize: 'Y', color: 'inkMuted' }
          },
          {
            ProcName: { text: '{{ cleaning | polyglot }}', fontSize: 'Y', color: 'inkText', fontWeight: '500' },
            ProcDate: { text: '2025-06-10', fontSize: 'Y', color: 'inkMuted' }
          }
        ]
      }
    }
  },

  ProcedureTimeline: {
    flow: 'y',
    gap: 'Y',

    TimelineHeader: {
      flow: 'x',
      align: 'center space-between',

      TimelineLabel: {
        text: '{{ procedureTimeline | polyglot }}',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 'X'
      },

      EntryCount: {
        text: (el, s) => {
          var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth]
          var count = history ? history.length : 0
          return count + ' entries'
        },
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '500'
      }
    },

    TimelineList: {
      flow: 'y',
      gap: '0',
      position: 'relative',

      TimelineLine: {
        position: 'absolute',
        left: '8px',
        top: '0',
        bottom: '0',
        width: '2px',
        background: 'inkBorder',
        show: (el, s) => {
          var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth]
          return history && history.length > 0
        }
      },

      TimelineEntries: {
        flow: 'y',
        gap: 'X',
        childExtends: {
          flow: 'x',
          gap: 'Z',
          padding: 'Z',
          paddingLeft: '0',
          round: 'Y',
          align: 'flex-start flex-start',
          position: 'relative',

          TimelineDot: {
            width: 'Y2',
            height: 'Y2',
            minWidth: 'Y2',
            round: 'C',
            background: 'teal',
            marginTop: 'X2',
            zIndex: '1',
            border: '2px solid inkSurface'
          },

          TimelineContent: {
            flow: 'y',
            gap: 'X',
            flex: '1',
            padding: 'X Z',
            round: 'Y',
            background: 'inkMid',
            border: '1px solid inkBorder',

            ContentTop: {
              flow: 'x',
              align: 'center space-between',
              gap: 'Y',

              ProcedureName: {
                fontSize: 'Z',
                fontWeight: '600',
                color: 'inkText'
              },

              VerifiedBadge: {
                fontSize: 'Y',
                fontWeight: '600',
                padding: 'X Y',
                round: 'B'
              }
            },

            ProcedureMeta: {
              flow: 'x',
              gap: 'Y',
              flexWrap: 'wrap',

              DoctorName: {
                fontSize: 'Y',
                color: 'inkMuted'
              },

              ClinicName: {
                fontSize: 'Y',
                color: 'inkMuted'
              }
            },

            ProcedureDate: {
              fontSize: 'Y',
              color: 'teal',
              fontWeight: '500'
            },

            ProcedureNotes: {
              fontSize: 'Y',
              color: 'inkMuted',
              fontStyle: 'italic'
            }
          }
        },
        $collection: (el, s) => {
          var history = s.root.toothHistory && s.root.toothHistory[s.root.selectedTooth]
          if (!history || !history.length) {
            return [{
              TimelineDot: { background: 'inkMuted', border: '2px solid inkSurface' },
              TimelineContent: {
                ContentTop: {
                  ProcedureName: { text: '{{ noHistory | polyglot }}' },
                  VerifiedBadge: { display: 'none' }
                },
                ProcedureMeta: { display: 'none' },
                ProcedureDate: { display: 'none' },
                ProcedureNotes: { display: 'none' }
              }
            }]
          }
          return history.map(function (entry) {
            var isVerified = entry.verified !== false
            return {
              TimelineDot: { background: isVerified ? 'teal' : 'orange' },
              TimelineContent: {
                ContentTop: {
                  ProcedureName: { text: entry.procedure },
                  VerifiedBadge: isVerified
                    ? { text: '{{ verified | polyglot }}', background: 'teal.15', color: 'teal' }
                    : { text: '{{ patientReported | polyglot }}', background: 'orange.15', color: 'orange' }
                },
                ProcedureMeta: {
                  DoctorName: { text: entry.doctor || '' },
                  ClinicName: { text: entry.clinic ? '- ' + entry.clinic : '' }
                },
                ProcedureDate: { text: entry.date },
                ProcedureNotes: entry.notes
                  ? { text: entry.notes }
                  : { display: 'none' }
              }
            }
          })
        }
      }
    }
  },

  AddHistoryButton: {
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    padding: 'Z A',
    round: 'Y',
    background: 'teal',
    color: 'white',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: 'Z',
    marginTop: 'Z',
    show: (el, s) => !s.root.showHistoryForm,

    ButtonIcon: {
      extends: 'Icon',
      icon: 'plus',
      fontSize: 'Z'
    },

    ButtonText: {
      text: '{{ addHistory | polyglot }}'
    },

    onClick: (el, s) => {
      s.root.update({ showHistoryForm: true })
    }
  },

  HistoryFormContainer: {
    show: (el, s) => s.root.showHistoryForm,
    marginTop: 'Z',
    PatientHistoryForm: {}
  },

  AddProcedureButton: {
    flow: 'x',
    gap: 'Y',
    align: 'center center',
    padding: 'Z A',
    round: 'Y',
    background: 'teal',
    color: 'white',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: 'Z',
    marginTop: 'Z',
    show: (el, s) => !s.root.showHistoryForm,

    ButtonIcon: {
      extends: 'Icon',
      icon: 'plus',
      fontSize: 'Z'
    },

    ButtonText: {
      text: '{{ addProcedure | polyglot }}'
    }
  }
}
